import React, { Suspense } from 'react';
import { Canvas } from '@react-three/fiber';
import { XR, createXRStore } from '@react-three/xr';
import Scene from './scene/Scene';
import HUD from './hud/HUD';
import './App.css';

const xrStore = createXRStore();

export default function App() {
  return (
    <div className="App">
      <Canvas
        camera={{ position: [0, 1.5, 10], fov: 50, near: 0.05, far: 100 }}
        dpr={[1, 2]}
        gl={{ antialias: true, alpha: false, powerPreference: 'high-performance' }}
      >
        <XR store={xrStore}>
          <Suspense fallback={null}>
            <Scene />
          </Suspense>
        </XR>
      </Canvas>
      <HUD xrStore={xrStore} />
    </div>
  );
}
